angular.module('ihestiaIkomunikator')
  .service('ihestiaIkomunikatorChooseCorrespondenceTypeHelper', ['$rootScope', '$filter', 'ihestiaSsoBaseInfoHelper', 'iHestiaCommonModalHelper',
    function($rootScope, $filter, ihestiaSsoBaseInfoHelper, iHestiaCommonModalHelper) {

      var ChooseCorrespondenceTypeHelper = function() {
        $rootScope.chooseCorrespondenceTypeModalSettings = {
          title: 'Wysyłka',
          okBtnName: $filter('translate')('Public.send'),
          okBtnDisabled: ihestiaSsoBaseInfoHelper.isUserRelogged(),
          cancelBtnName: $filter('translate')('Public.cancel'),
          size: 'sm'
        };

        /**
         * Pokazujemy modal wyboru typu rodzaju korespondencji
         * @param {object|undefined} options - dodatkowe ustawienia
         * @return {[type]} [description]
         */
        this.showModal = function() {
          iHestiaCommonModalHelper.showModal('ihestiaIkomunikatorChooseCorrespondenceType');
        };

        /**
         * Ukrywamy modal wyboru typu rodzaju korespondencji
         * @return {[type]} [description]
         */
        this.hideModal = function() {
          iHestiaCommonModalHelper.hideModal('ihestiaIkomunikatorChooseCorrespondenceType');
        };

      };

      return new ChooseCorrespondenceTypeHelper();
    }
  ]);